// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"1e4e02b5","472":"aa81bb76","488":"5d648ff5","680":"5b8ae82e","805":"4f2f57b6","888":"4821fc2a"}[chunkId] + ".chunk.js";
};